import { defineComponent as _defineComponent } from 'vue'
import { BaseText } from '@warrenbrasil/nebraska-web';
import RegulationItem from './components/RegulationItem.vue';
import type { RLPPageData } from '@/modules/trade/services/rlp';

interface Props {
  pageData: RLPPageData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Regulation',
  props: {
    pageData: null
  },
  setup(__props: any) {



return { __sfc: true,BaseText, RegulationItem }
}

})